const isMobile = () => window.matchMedia("(max-width: 575px)").matches;

document.querySelectorAll<HTMLElement>(".footer-column").forEach((column) => {
  const header = column.querySelector<HTMLButtonElement>(".footer-column--header");
  if (!header) return;

  header.addEventListener("click", () => {
    if (!isMobile()) return;
    const isOpen = column.classList.toggle("is-open");
    header.setAttribute("aria-expanded", String(isOpen));
  });
});
